import { setLocale as setParalocale } from '@pricedrop/i18n';
import { DEFAULT_LOCALE, getDirection, localeToLanguageTag } from '@pricedrop/i18n/locales';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_public')({
  beforeLoad: async () => {
    const langTag = localeToLanguageTag(DEFAULT_LOCALE);
    setParalocale(langTag, { reload: false });

    if (typeof document !== 'undefined') {
      document.documentElement.lang = DEFAULT_LOCALE;
      document.documentElement.dir = getDirection(DEFAULT_LOCALE);
    }
  },
  component: PublicLayout,
});

function PublicLayout() {
  return <Outlet />;
}
